import { render, staticRenderFns } from "./General.vue?vue&type=template&id=60a5d488&"
import script from "./General.vue?vue&type=script&lang=js&"
export * from "./General.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60a5d488')) {
      api.createRecord('60a5d488', component.options)
    } else {
      api.reload('60a5d488', component.options)
    }
    module.hot.accept("./General.vue?vue&type=template&id=60a5d488&", function () {
      api.rerender('60a5d488', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/partners/General.vue"
export default component.exports